import _ from "lodash";
import React, { useEffect, useState } from "react";
import { DesktopContainer } from "../layouts";
import Select from "react-select";
import { Button, Col, Row, Input } from "reactstrap";  // Alert as ReactstrapAlert, 
import { api, constants, dateHelpers, filterHelpers } from "../utils";
import { EmployeeTransactionEntry, FilterableScreen } from "./";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
//import { type } from "jquery";

const today = new Date();
const currentDate = dateHelpers.dateTimeFormat(today, "YYYY-MM-DD");
const pastDate = dateHelpers.addDays(today, -90);

export default function EmployeeAttendanceReport(props) {
   const [absenceTypes, setAbsenceTypes] = useState([]);
   const [employees, setEmployees] = useState([]);
   const [endPointRange, setEndPointRange] = useState("");
   const [filters, setFilters] = useState([
      { filterName: "startDate", value: pastDate },
      { filterName: "endDate", value: today },
   ]);
   const [firstNames, setFirstNames] = useState([]);
   const [formattedEmployeeList, setFormattedEmployeeList] = useState([]);
   const [includeFirstName, setIncludeFirstName] = useState(false);
   const [isDownloading, setIsDownloading] = useState(false);
   const [lastNames, setLastNames] = useState([]);
   const [selectedAbsenceType, setSelectedAbsenceType] = useState({ label: "All", value: "" });
   const [selectedFirstName, setSelectedFirstName] = useState({ label: "--- Select Employee ---", value: "" })
   const [selectedLastName, setSelectedLastName] = useState({ label: "--- All ---", value: "" });
   const [selectedSupervisor, setSelectedSupervisors] = useState({ label: "--- All ---", value: "" });
   const [selectedTimeCode, setSelectedTimeCode] = useState({ label: "--- All ---", value: "" });
   const [startPointRange, setStartPointRange] = useState("");
   const [supervisors, setSupervisors] = useState([]);
   const [timeCodes, setTimeCodes] = useState([]);

   useEffect(() => {
      document.title = `Employee Attendance`;
      getEmployeeAbsenceTypes();
      getTimeCodes();
      getSupervisors();
      getEmployees();
   }, []);

   function getEmployeeAbsenceTypes() {
      api
         .fetch("Reference/GetEmployeeAbsenceTypes")
         .then((response) => {
            if (response && response.data.success) {
               let list = _.map(response.data.message, (x) => {
                  return {
                     label: x.attendanceType,
                     value: x.attendanceType,
                  };
               });
               let sortedList = _.sortBy(list, ["label"]);
               sortedList.unshift({ label: "All", value: "" });
               setAbsenceTypes(sortedList);
            } else {
               toast.error("Failed to fetch Employee Absence Types.");
            }
         })
         .catch(api.catchHandler);
   }

   function getEmployees() {
      api
         .fetch("Reference/GetEmployeeList")
         .then((response) => {
            if (response && response.data.success) {
               setEmployees(response.data.message);
               let nameList = _.map(response.data.message, (x) => {
                  return {
                     label: x.lastname,
                     value: x.lastname,
                  };
               });
               let sortedNameList = _.sortBy(nameList, ["label"]);
               sortedNameList.unshift({ label: "--- All ---", value: "" });
               setLastNames(sortedNameList);
               let list = _.map(response.data.message, (x) => {
                  return {
                     label: x.employeeNameLastFirst,
                     value: x.employid,
                  };
               });
               list.unshift({ label: "--- Select Employee---", value: "" });
               setFormattedEmployeeList(_.sortBy(list, ["label"]));
            } else {
               toast.error("Failed to fetch Employees.");
            }
         })
         .catch(api.catchHandler);
   }

   function getSupervisors() {
      api
         .fetch("Reference/GetSupervisors")
         .then((response) => {
            if (response && response.data.success) {
               let list = _.map(response.data.message, (x) => {
                  return {
                     label: `${x.supervisor} - ${x.fullName}`,
                     value: x.supervisorcodE_I,
                  };
               });
               let sortedList = _.sortBy(list, ["label"]);
               sortedList.unshift({ label: "--- All ---", value: "" });
               setSupervisors(sortedList);
            } else {
               toast.error("Failed to get supervisors.");
            }
         })
         .catch(api.catchHandler);
   }

   function getTimeCodes() {
      api
         .fetch("Reference/GetTimeCodes")
         .then((response) => {
            if (response && response.data.success) {
               let list = _.map(response.data.message, (x) => {
                  return {
                     label: x.description,
                     value: x.timeCode,
                  };
               });
               let sortedList = _.sortBy(list, ["label"]);
               sortedList.unshift({ label: "--- All ---", value: "" });
               setTimeCodes(sortedList);
            } else {
               toast.error("Failed to fetch Time Codes");
            }
         })
         .catch(api.catchHandler);
   }

   function handleSelectLastName(lastName) {
      let filteredArr = _.filter(lastNames, ['value', lastName.value]);
      if (filteredArr.length === 1) {
         setSelectedLastName(lastName);
         setIncludeFirstName(false);
         setSelectedFirstName({
            label: "--- Select Employee ---",
            value: ""
         });
         return;
      } else {
         setIncludeFirstName(true);
         setSelectedFirstName({
            label: "--- Select Employee ---",
            value: ""
         });
         setSelectedLastName(lastName);
         let firstNames = [];

         _.forEach(employees, function (x) {
            if (x.lastname === lastName.value) {
               firstNames.push({
                  label: x.frstname,
                  value: x.frstname
               });
            }
         });

         setFirstNames(firstNames);
      }
   }

   function runReport() {
      if (
         !filterHelpers.getValue(filters, "startDate") ||
         !filterHelpers.getValue(filters, "endDate")
         // ||
         // !startPointRange ||
         // !endPointRange
      ) {
         toast.error("Please make sure dates and point values are entered.");
         return;
      }

      setIsDownloading(true);
      let payload = {
         supervisorCode: selectedSupervisor?.value,
         lastName: selectedLastName?.value,
         startDate: filterHelpers.getValue(filters, "startDate"),
         endDate: filterHelpers.getValue(filters, "endDate"),
         startPointRange: startPointRange.length ? startPointRange : null,
         endPointRange: endPointRange.length ? endPointRange : null,
         absenceType: selectedAbsenceType?.value,
         timeCode: selectedTimeCode?.value,
         firstName: selectedFirstName?.value
      };
      api
         .postDownloadBinary(
            "Report/GetEmployeeAttendanceReport",
            payload,
            constants.MIME_TYPES.pdf,
            `Employee_Attendance_Report_${currentDate}`,
            "There was an error downloading the employee attendance report."
         )
         .then((response) => {
            if (response?.data === false) {
               toast.error(response.message);
            }
         })
         .catch(api.catchHandler)
         .finally(() => setIsDownloading(false));
   }

   return (
      <>
         <EmployeeTransactionEntry
            timeCodes={timeCodes}
            absenceTypes={absenceTypes}
            employees={employees}
            formattedEmployeeList={formattedEmployeeList}
         />
         <DesktopContainer screenName="Employee Attendance Report">
            <FilterableScreen
               filters={
                  <div className="filter-header stick-top mb-3">
                     <Row className="mt-3">
                        <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }} >
                           <h5>Supervisor:</h5>
                        </Col>
                        <Col xs="6">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={supervisors}
                              value={selectedSupervisor}
                              onChange={(e) => setSelectedSupervisors(e)}
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }} >
                           <h5>Last Name:</h5>
                        </Col>
                        <Col xs="6">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={lastNames}
                              value={selectedLastName}
                              // onChange={(e) => setSelectedLastName(e)}
                              onChange={(e) => handleSelectLastName(e)}
                           />
                        </Col>
                     </Row>
                     {includeFirstName ? (
                        <Row className="mt-3">
                           <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }} >
                              <h5>First Name:</h5>
                           </Col>
                           <Col xs="6">
                              <Select
                                 classNamePrefix="serviceThreadSelect"
                                 options={firstNames}
                                 value={selectedFirstName}
                                 onChange={(e) => setSelectedFirstName(e)}
                              />
                           </Col>
                        </Row>
                     ) : null}
                     <Row className="mt-3">
                        <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }} >
                           <h5>Time Code:</h5>
                        </Col>
                        <Col xs="6">
                           <Select
                              className="serviceThreadSelect"
                              classNamePrefix="serviceThreadSelect"
                              options={timeCodes}
                              value={selectedTimeCode}
                              onChange={(e) => setSelectedTimeCode(e)}
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }} >
                           <h5>Type:</h5>
                        </Col>
                        <Col xs="6">
                           <Select
                              classNamePrefix="serviceThreadSelect"
                              options={absenceTypes}
                              value={selectedAbsenceType}
                              onChange={(e) => setSelectedAbsenceType(e)}
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }} >
                           <h5>Start Date:</h5>
                        </Col>
                        <Col xs="6">
                           <DatePicker
                              className="form-control"
                              selected={filterHelpers.getValue(filters, "startDate")}
                              onChange={(newValue) => {
                                 setFilters(
                                    filterHelpers.getFilters(filters, {
                                       filterName: "startDate",
                                       value: newValue,
                                       filteredDisplay: `Start Date: ${newValue}`,
                                    })
                                 );
                              }}
                              dateFormat="yyyy-MM-dd"
                              placeholderText="Select a date"
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }} >
                           <h5>End Date:</h5>
                        </Col>
                        <Col xs="6">
                           <DatePicker
                              className="form-control"
                              selected={filterHelpers.getValue(filters, "endDate")}
                              onChange={(newValue) =>
                                 setFilters(
                                    filterHelpers.getFilters(filters, {
                                       filterName: "endDate",
                                       value: newValue,
                                       filteredDisplay: `End Date: ${newValue}`,
                                    })
                                 )
                              }
                              dateFormat="yyyy-MM-dd"
                              placeholderText="Select a date"
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }} >
                           <h5>Start Point Range:</h5>
                        </Col>
                        <Col xs="6">
                           <Input
                              type="number"
                              value={startPointRange}
                              onChange={(e) => setStartPointRange(e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xs="3" style={{ textAlign: "right", marginRight: "5px", color: "white" }} >
                           <h5>End Point Range:</h5>
                        </Col>
                        <Col xs="6">
                           <Input
                              type="number"
                              value={endPointRange}
                              onChange={(e) => setEndPointRange(e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="mt-3">
                        <Col xs="3" style={{ textAlign: "right", marginRight: "5px" }} >
                           <Button
                              className="shredButton"
                              disabled={isDownloading}
                              onClick={() => runReport()}
                           >
                              RUN REPORT
                           </Button>
                        </Col>
                        <Col xs="6"></Col>
                     </Row>
                  </div>
               }
            ></FilterableScreen>
         </DesktopContainer>
      </>
   );
}
